// ClickObsessed Theme JS v4

// ============================================
// CUSTOM CURSOR
// ============================================
const cursor = document.getElementById('cursor');
const ring = document.getElementById('cursorRing');
if (cursor && ring) {
  let mouseX = 0, mouseY = 0, ringX = 0, ringY = 0;
  document.addEventListener('mousemove', e => {
    mouseX = e.clientX; mouseY = e.clientY;
    cursor.style.transform = `translate(${mouseX - 6}px, ${mouseY - 6}px)`;
  });
  function animateRing() {
    ringX += (mouseX - ringX - 18) * 0.12;
    ringY += (mouseY - ringY - 18) * 0.12;
    ring.style.transform = `translate(${ringX}px, ${ringY}px)`;
    requestAnimationFrame(animateRing);
  }
  animateRing();
  document.querySelectorAll('a, button, .faq-item, .feature-card, .review-card, .option-btn').forEach(el => {
    el.addEventListener('mouseenter', () => { ring.style.width = '60px'; ring.style.height = '60px'; });
    el.addEventListener('mouseleave', () => { ring.style.width = '36px'; ring.style.height = '36px'; });
  });
}

// ============================================
// SCROLL REVEAL
// ============================================
const revealObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      entry.target.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll('.feature-card, .review-card').forEach(el => revealObserver.observe(el));

// ============================================
// FAQ ACCORDION
// ============================================
document.querySelectorAll('.faq-item').forEach(item => {
  item.addEventListener('click', () => item.classList.toggle('open'));
});

// ============================================
// VARIANT SELECTOR
// ============================================
document.querySelectorAll('.option-buttons').forEach(group => {
  group.querySelectorAll('.option-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      // Remove active from all buttons in this group
      group.querySelectorAll('.option-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      // Update ALL variant inputs on the page
      document.querySelectorAll('#variant-id').forEach(input => {
        input.value = variantId;
      });

      // Also update add to cart button text/data
      const addBtn = document.getElementById('add-to-cart-btn');
      if (addBtn) addBtn.dataset.variantId = variantId;

      console.log('Variant selected:', variantId, btn.textContent.trim());
    });
  });
});

// ============================================
// CART — fully working add/update/remove/render
// ============================================
const cartOverlay = document.getElementById('cart-overlay');
const cartDrawer = document.getElementById('cart-drawer');
const cartClose = document.getElementById('cart-close');
const cartCountEl = document.getElementById('cart-count');

function openCart() {
  if (cartOverlay) cartOverlay.classList.add('open');
  if (cartDrawer) cartDrawer.classList.add('open');
  fetchCart();
}

function closeCart() {
  if (cartOverlay) cartOverlay.classList.remove('open');
  if (cartDrawer) cartDrawer.classList.remove('open');
}

if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
if (cartClose) cartClose.addEventListener('click', closeCart);

// Expose fetchCart globally so inline scripts can call it
window.fetchCart = async function() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCart(cart);
    if (cartCountEl) {
      cartCountEl.textContent = cart.item_count;
      cartCountEl.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    }
  } catch(e) { console.error('Cart fetch error', e); }
};

function renderCart(cart) {
  const itemsEl = document.getElementById('cart-items');
  const totalEl = document.getElementById('cart-total-price');
  const checkoutBtn = document.getElementById('checkout-btn');

  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = `
      <div class="cart-empty">
        <div style="font-size:40px;margin-bottom:12px;">🛒</div>
        <div style="font-weight:500;margin-bottom:6px;color:var(--white);">Your cart is empty</div>
        <div>Add something amazing!</div>
      </div>`;
    if (checkoutBtn) checkoutBtn.style.opacity = '0.4';
  } else {
    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img src="${item.image}" alt="${item.title}" class="cart-item-img">
        <div class="cart-item-info">
          <div class="cart-item-name">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<div class="cart-item-variant">${item.variant_title}</div>`
            : ''}
          <div class="cart-item-price">$${(item.price / 100).toFixed(2)}</div>
          <div class="cart-item-qty">
            <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})">−</button>
            <span class="qty-num">${item.quantity}</span>
            <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
            <button class="remove-btn" onclick="changeQty('${item.key}', 0)" title="Remove">🗑</button>
          </div>
        </div>
      </div>
    `).join('');
    if (checkoutBtn) checkoutBtn.style.opacity = '1';
  }

  if (totalEl) totalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
}

// Change quantity by line item key (supports 0 = remove)
window.changeQty = async function(key, quantity) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    });
    fetchCart();
  } catch(e) { console.error('Cart update error', e); }
};

// Add to cart by variant ID
window.addToCart = async function(variantId, quantity = 1) {
  if (!variantId) { console.error('No variant ID'); return; }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity })
    });
    if (!res.ok) {
      const err = await res.json();
      console.error('Add to cart error:', err);
      return;
    }
    openCart();
  } catch(e) { console.error('Add to cart error', e); }
};

// Main add-to-cart button
const addBtn = document.getElementById('add-to-cart-btn');
if (addBtn) {
  addBtn.addEventListener('click', () => {
    // Always read from the hidden input which gets updated by variant selector
    const variantInput = document.getElementById('variant-id');
    const variantId = variantInput ? variantInput.value : addBtn.dataset.variantId;
    console.log('Adding to cart variant:', variantId);
    addToCart(variantId);
  });
}

// Header cart icon
const headerCart = document.getElementById('header-cart');
if (headerCart) headerCart.addEventListener('click', openCart);

// Header scroll effect
window.addEventListener('scroll', () => {
  const header = document.querySelector('.site-header');
  if (header) header.classList.toggle('scrolled', window.scrollY > 50);
}, { passive: true });

// Init — load cart count on page load
fetchCart();
